export enum IncidentStatuses {
  Draft = 0,
  Open = 1,
  Closed = 2,
}
